import { render, staticRenderFns } from "./Barrage.vue?vue&type=template&id=1888b8c3&scoped=true&"
import script from "./Barrage.vue?vue&type=script&lang=js&"
export * from "./Barrage.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/activity/wickedcss.css?vue&type=style&index=0&lang=css&"
import style1 from "./Barrage.vue?vue&type=style&index=1&id=1888b8c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1888b8c3",
  null
  
)

export default component.exports